import React from 'react';
import ReactDOM from 'react-dom';
import { Router, IndexRoute, browserHistory } from 'react-router';
import { createStore, combineReducers } from 'redux';
import { Provider } from 'react-redux';

import appReducer from './reducers/app-reducer';
import App from './App';
import Home from './components/home';
import Download from './components/download';
import Contact from './components/contact';
import './index.css';
// import './font-awesome.min.css';

const combinedReducers = combineReducers({
    appState: appReducer
});

const store = createStore(combinedReducers);

store.subscribe(() => console.log('state', store.getState()));

ReactDOM.render((
    <Provider store={store}>
        <Router history={browserHistory}>
            <Router path="/" component={App}>
                <IndexRoute component={Home}></IndexRoute>
                <Router path="downloads" component={Download}></Router>
                <Router path="contact" component={Contact}></Router>
            </Router>
        </Router>
    </Provider>
),
document.getElementById('root'));



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/